import { FC } from "react";
import { useNavigate } from "react-router-dom";
import {
  Box,
  Typography,
  Card,
  Button,
  Grid,
  Divider,
} from "@mui/material";
import { ErrorOutline } from "@mui/icons-material";
import { ProfileBorderBox } from "../../../../../shared/components/profileComponents";

const PaymentFailure: FC = () => {
  const navigate = useNavigate();

  return (
    <ProfileBorderBox>
      <Box sx={{ display: "flex", justifyContent: "flex-end", mb: 2, pr: 2 }}></Box>

      <Box
        sx={{
          minHeight: "calc(100vh - 64px)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          background: "linear-gradient(to bottom right, #f0f4ff, #e2f0e9)",
          py: 5,
        }}
      >
        <Card
          elevation={6}
          sx={{
            maxWidth: 600,
            width: "100%",
            px: 4,
            py: 5,
            borderRadius: 4,
            textAlign: "center",
            backgroundColor: "#ffffff",
          }}
        >
          <ErrorOutline sx={{ fontSize: 72, color: "red", mb: 2 }} />

          <Box width="100%" display="flex" justifyContent="center">
            <Typography
              variant="h4"
              fontWeight={600}
              gutterBottom
              align="center"
              sx={{ whiteSpace: "nowrap" }}
            >
              Payment&nbsp;Failed
            </Typography>
          </Box>

          <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
            Oops! Something went wrong. Please try again or contact support.
          </Typography>

          <Divider sx={{ my: 3 }} />

          <Grid container spacing={2} justifyContent="center">
            <Grid item>
              <Button
                variant="contained"
                size="large"
                onClick={() => navigate("/fee/feeDetails")}
                color="error"
                sx={{ px: 3 }}
              >
                Retry Payment
              </Button>
            </Grid>
            <Grid item>
              <Button
                variant="contained"
                size="large"
                 color="primary"
                onClick={() => navigate("/fee/paymentHistory")}
                sx={{ px: 3 }}
              >
                View Payment History
              </Button>
            </Grid>
          </Grid>
        </Card>
      </Box>
    </ProfileBorderBox>
  );
};

export default PaymentFailure;
